<template>
  <v-tooltip top>
    <template v-slot:activator="{ on }">
      <v-menu
        v-model="menu"
        :close-on-content-click="false"
        right
        offset-x
        min-width="400"
        :disabled="!valid || disabled"
      >
        <v-btn
          slot="activator"
          :disabled="!valid || disabled"
          class="my-2 mx-2"
          color="primary"
          small
          v-on="on"
        >
          Добавить поставку
        </v-btn>
        <v-card>
          <v-form v-model="isValid">
            <v-card-text>
              <h1 class="subheading font-weight-bold mb-3">
                Информация о поставке
              </h1>
              <v-layout column>
                <v-flex>
                  <ShippingSelect
                    v-model="selected"
                    :client-id="client ? client.id : ''"
                    :sender-id="sender ? sender.id : ''"
                    @input="getShippingInfo"
                  />
                </v-flex>
                <v-flex>
                  <app-reference
                    v-model="client"
                    :outline="true"
                    class="my-3"
                    label="Клиент"
                    :height-field="44"
                    resource="clients"
                    component-name="Client"
                  />
                </v-flex>
                <v-flex xs6>
                  <app-reference
                    v-model="sender"
                    :outline="true"
                    label="Продавец"
                    resource="factories"
                    component-name="Factory"
                    :without-parent-lock="true"
                    :height-field="44"
                  />
                </v-flex>
                <v-flex>
                  <DecimalEditor
                    v-model="volume"
                    label="Объем к отгрузке"
                    :scale="3"
                    :disabled="!isPartial"
                    outline
                    class="my-3"
                    @input="isChanged = true"
                  />
                </v-flex>
                <v-flex>
                  <DecimalEditor
                    v-model="cargoPlaces"
                    label="К-во мест к отгрузке"
                    :disabled="!isPartial"
                    outline
                    @input="isChanged = true"
                  />
                </v-flex>
                <v-flex>
                  <v-switch
                    v-model="isPartial"
                    :label="
                      isPartial
                        ? 'Частичная выдача товара'
                        : 'Полная выдача товара'
                    "
                    color="red lighten-1"
                    hide-details
                    class="switch-color my-3 pt-0"
                    :disabled="disableAddNotIsPartial"
                    @change="isChanged = true"
                  />
                </v-flex>
                <v-flex>
                  <v-text-field
                    v-model="number"
                    label="Номер заказа, проформы или др.идентификатор*"
                    :disabled="!isPartial"
                    outline
                    height="44"
                    hide-details
                    class="my-2"
                  />
                </v-flex>
                <v-flex>
                  <v-text-field
                    v-model="notes"
                    label="Комментарии"
                    height="44"
                    hide-details
                    outline
                    @input="isChanged = true"
                  />
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions class="">
              <v-layout align-center>
                <v-btn
                  small
                  color="primary"
                  class="my-0 ml-0 mr-2"
                  :disabled="!(isValid && isChanged)"
                  :loading="loading"
                  @click="saveItem"
                >
                  Сохранить
                </v-btn>
                <v-btn
                  small
                  class="ma-0"
                  @click="cancel"
                >
                  Отмена
                </v-btn>
              </v-layout>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-menu>
    </template>
    <span>Добавить поставку в список на отгрузку</span>
  </v-tooltip>
</template>
<script>
import * as releaseOrders from "../../../backend/releaseOrdersApi.js";
import * as basErpApi from "../../../backend/basErpApi.js";
import ShippingSelect from "./ShippingSelect.vue";

export default {
  components: { ShippingSelect },
  props: ["id", "valid", "disabled", "disableAddNotIsPartial"],
  data() {
    return {
      selected: null,
      client: null,
      sender: null,
      volume: null,
      cargoPlaces: null,
      isPartial: false,
      number: "",
      notes: "",
      isChanged: false,
      menu: false,
      isValid: false,
      needSync: false,
      loading: false,
    };
  },
  watch: {
    disableAddNotIsPartial: {
      handler(newValue) {
        this.isPartial = newValue;
      },
      immediate: true,
    },
  },
  methods: {
    async saveItem() {
      const item = {
        shippingId: this.selected.id,
        volume: this.volume,
        cargoPlaces: this.cargoPlaces,
        isPartial: this.isPartial,
        number: this.number,
        notes: this.notes,
      };
      if (this.id > 0) {
        this.loading = true;
        await releaseOrders.createReleaseOrdersShipping(this.id, item);
        this.cancel();
        await this.$store.dispatch("releaseOrders/getShippings", this.id);
        this.needSync = await basErpApi.getNeedSync(this.id);
        this.$store.commit("releaseOrders/setNeedSync", this.needSync);
        this.loading = false;
      } else {
        this.cancel();
        this.loading = false;
        this.$emit("saveAfter", item);
      }
    },
    cancel() {
      this.menu = false;
      this.selected = null;
      this.client = null;
      this.sender = null;
      this.volume = null;
      this.cargoPlaces = null;
      this.isPartial = this.disableAddNotIsPartial;
      this.number = "";
      this.notes = "";
      this.isChanged = false;
    },
    async getShippingInfo() {
      if (!this.selected?.id) {
        return;
      }
      const shipping = await releaseOrders.getReleaseOrdersShipping(
        this.selected.id,
      );
      this.volume = shipping.volume;
      this.cargoPlaces = shipping.cargoPlaces;
      this.isChanged = true;
    },
  },
};
</script>
